import styled from 'styled-components';
import { Flex, MarginBox } from 'UI';

export const BrandTabLayout = styled(Flex)``;

export const FilterColumn = styled(Flex)`
  flex-direction: column;
`;

export const ResultsColumn = styled(Flex)`
  flex-direction: column;
`;

export const ColumnsSpacer = styled.div<{ $large: boolean }>`
  margin-right: ${({ $large, theme }) => ($large ? `${theme.spacing.spacing_xs}px` : '0')};
  margin-top: ${({ $large, theme }) => ($large ? '0' : `${theme.spacing.spacing_xs}px`)};
`;

export const ToggleWrapper = styled(MarginBox).attrs({ mt: 20 })``;

export const TopMarginWrapper = styled(MarginBox).attrs(({ theme }) => ({ mt: theme.spacing.spacing_xs }))``;
